export { default } from './SmartGoals';
